'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixRestaurantsJsSdk = require('wix-restaurants-js-sdk');

exports.default = _wixRestaurantsJsSdk.helpers.Image;


//////////////////
// WEBPACK FOOTER
// ../node_modules/openrest4js/dist/openrest4js-helpers/Image.js
// module id = 1105
// module chunks = 0